export default {"src":"/_next/static/media/logo_wordmark.57cf15b4.svg","height":26,"width":102};